import React from 'react'
import { Hero } from '../Hero/Hero'

export const Home = () => {
  return (
  <div className="home">
   <Hero/>
  </div>
  )
}
